export const SAVED_RULES_PRESET_NAME_PREFIX = 'firewall:';

export const getSavedRulesPresetName = (uniqId: string) =>
	`${SAVED_RULES_PRESET_NAME_PREFIX}${uniqId}`;
